export default "__VITE_ASSET__BdPDYPjI__"